export { default as StrategyFloatingProgress } from './StrategyFloatingProgress';
